import { ProductTypeCreate } from './ProductTypeCreate'
import { ProductTypeEdit } from './ProductTypeEdit'
import { ProductTypeList } from './ProductTypeList'
import { ProductTypeShow } from './ProductTypeShow'

export { ProductTypeCreate, ProductTypeEdit, ProductTypeList, ProductTypeShow }
